import { addJsApi } from '@tencent/qb-local-jsapi-h5';

const versionNotMatchCallback = (result: { type: any; data: { apiName: any; appVersion: any; }; }) => {
  const { type, data: { apiName, appVersion } } = result;
  console.log(`api ${apiName}, failCallback type: ${type}, appVersion: ${appVersion}`);
};

// 半浮层组件native支持jsapi调用
const addShowHalfFloatingViewOpt = {
  android: {
    version: '13.0.0',
    code: () => {
      // copy https://qbjsapi.oa.com/ 文档中对应的android的实现逻辑 == start ==
      window.browser.define('browser.app.showHalfFloatingView', (callback: any, failCallback: any, options: any) => {
        window.qb_bridge.exec(callback, failCallback, 'app', 'showHalfFloatingView', options);
      });
      // copy https://qbjsapi.oa.com/ 文档中对应的android的实现逻辑 == end ==
    },
  },
  ios: {
    version: '13.0.0',
    code: () => {
      // copy https://qbjsapi.oa.com/ 文档中对应的ios的实现逻辑 == start ==
      window.browser.define('browser.app.showHalfFloatingView', (callback: any, failCallback: any, options: any) => {
        window.x5.exec(callback, failCallback, 'app', 'showHalfFloatingView', [options]);
      });
      // copy https://qbjsapi.oa.com/ 文档中对应的ios的实现逻辑 == end ==
    },
  },
  versionNotMatchCallback,
};

const dismissHalfFloatingViewOpt = {
  android: {
    version: '13.0.0',
    code: () => {
      window?.browser?.define('browser.app.dismissHalfFloatingView', (callback: any, failCallback: any) => {
        window.qb_bridge.exec(callback, failCallback, 'app', 'dismissHalfFloatingView', null);
      });
    },
  },
  ios: {
    version: '13.0.0',
    code: () => {
      window?.browser.define('browser.app.dismissHalfFloatingView', (callback: any, failCallback: any) => {
        window.x5.exec(callback, failCallback, 'app', 'dismissHalfFloatingView', []);
      });
    },
  },
  versionNotMatchCallback,
};


const historyBackInitOpt = {
  apiName: 'app.historyBack',
  android: {
    version: '5.7',
    code: () => {
      // copy https://qbjsapi.oa.com/ 文档中对应的android的实现逻辑 == start ==
      window.browser.define('browser.app.historyBack', () => {
        window.qb_bridge.exec(null, null, 'app', 'historyBack', null);
      });
      // copy https://qbjsapi.oa.com/ 文档中对应的android的实现逻辑 == end ==
    },
  },
  ios: {
    version: '5.7',
    code: () => {
      // copy https://qbjsapi.oa.com/ 文档中对应的ios的实现逻辑 == start ==
      window.browser.define('browser.app.historyBack', () => {
        window.x5.exec(() => { }, () => { }, 'app', 'historyBack', []);
      });
      // copy https://qbjsapi.oa.com/ 文档中对应的ios的实现逻辑 == end ==
    },
  },
  versionNotMatchCallback,
};

const copyOpt = {
  android: {
    version: '7.2',
    code: () => {
      window?.browser?.define('browser.device.copy', (strCopy: any, succCallback: any, errCallback: any) => {
        const opt = { text: strCopy };
        try {
          window.qb_bridge.exec(null, null, 'device', 'copy', opt);
          succCallback?.();
        } catch (ex) {
          errCallback?.(ex);
        }
      });
    },
  },
  ios: {
    version: '6.4',
    code: () => {
      window?.browser?.define('browser.device.copy', (strCopy: any, succCallback: any, errCallback: any) => {
        window.x5.exec(succCallback, errCallback, 'device', 'copy', [{ strCopy }]);
      });
    },
  },
  versionNotMatchCallback,
};

const openUrlOpt = {
  android: {
    version: '7.2',
    code: () => {
      window?.browser?.define('browser.app.openUrl', (succCallback: any, errCallback: any, options: any) => {
        options.succCallback = String(succCallback);
        options.errCallback = String(errCallback);
        window.qb_bridge.exec(null, null, 'qb', 'openUrl', options);
      });
    },
  },
  ios: {
    version: '5.6',
    code: () => {
      window?.browser?.define('browser.app.openUrl', (succCallback: any, errCallback: any, options: any) => {
        window.x5.exec(succCallback, errCallback, 'app', 'openUrl', [options]);
      });
    },
  },
  versionNotMatchCallback,
};

const refreshTokenOpt = {
  android: {
    version: '7.2',
    code: () => {
      window?.browser?.define('browser.login.refreshToken', (options: { [x: string]: string; }, callback: any) => {
        window.refreshTokenCallback = callback;
        const cb = function (callBackParam: any) {
          window.refreshTokenCallback?.(callBackParam);
          window.refreshTokenCallback = null;
        };
        options.succCallback = String(cb);
        window.qb_bridge.exec(null, null, 'account', 'refreshToken', options);
      });
    },
  },
  ios: {
    version: '5.7',
    code: () => {
      window?.browser?.define('browser.login.refreshToken', (options: { [x: string]: string; }, callback: any) => {
        window.x5.exec(callback, callback, 'login', 'refreshToken', [options]);
      });
    },
  },
  versionNotMatchCallback,
};

const showLoginPanelOpt = {
  android: {
    version: '7.2',
    code: () => {
      window?.browser.define('browser.login.showLoginPanel', (succCallback: any, errCallback: any, options: any) => {
        if (!options) {
          options = {};
        }

        window.coolread_showLoginPanel_callback = succCallback || function (info: any) {
          console.log('🚀 ~ file: jsApi.ts:162 ~ window?.browser.define ~ info:', info);
        };
        options.succCallback = String((info: any) => {
          window.coolread_showLoginPanel_callback(info);
        });

        options.failCallback = String(errCallback);
        window.qb_bridge.exec(null, null, 'account', 'showLoginPanel', options);
      });
    },
  },
  ios: {
    version: '5.0',
    code: () => {
      window?.browser?.define('browser.login.showLoginPanel', (succCallback: any, errCallback: any, options: any) => {
        window.x5.exec(succCallback, errCallback, 'login', 'showLoginPanel', options ? [options] : []);
      });
    },
  },
  versionNotMatchCallback,
};

const getSocialMediaTokenInfoOfPhoneOpt = {
  android: {
    version: '11.5.5',
    code: () => {
      window?.browser?.define('browser.login.getSocialMediaTokenInfoOfPhone', (succCallback: any, options: any) => {
        window.qb_bridge.exec(succCallback, null, 'account', 'getSocialMediaTokenInfoOfPhone', options);
      });
    },
  },
  ios: {
    version: '11.5.5',
    code: () => {
      window?.browser?.define('browser.login.getSocialMediaTokenInfoOfPhone', (succCallback: any, options: any) => {
        window.x5.exec(succCallback, null, 'login', 'getSocialMediaTokenInfoOfPhone', options ? [options] : []);
      });
    },
  },
  versionNotMatchCallback,
};

const buyResourceOpt = {
  android: {
    version: '13.7.5',
    code: () => {
      window?.browser?.define('browser.simplePay.buyResource', (succCallback: any, options: any) => {
        window?.qb_bridge.exec(succCallback, () => { }, 'simplePay', 'buyResource', options);
      });
    },
  },
  ios: {
    version: '13.7.5',
    code: () => {
      window?.browser?.define('browser.simplePay.buyResource', (succCallback: any, options: any) => {
        window.x5.exec(succCallback, () => { }, 'simplePay', 'buyResource', [options]);
      });
    },
  },
  versionNotMatchCallback,
};

const notifyBuyResultOpt = {
  android: {
    version: '13.7.5',
    code: () => {
      window?.browser?.define('browser.simplePay.notifyBuyResult', (succCallback: any, options: any) => {
        window?.qb_bridge.exec(succCallback, null, 'simplePay', 'notifyBuyResult', options);
      });
    },
  },
  ios: {
    version: '13.7.5',
    code: () => {
      window?.browser?.define('browser.simplePay.notifyBuyResult', (succCallback: any, options: any) => {
        window.x5.exec(succCallback, null, 'simplePay', 'notifyBuyResult', [options]);
      });
    },
  },
  versionNotMatchCallback,
};

// 定义好方法对象,通过addJsApi引入
addJsApi(dismissHalfFloatingViewOpt);
addJsApi(addShowHalfFloatingViewOpt);
addJsApi(historyBackInitOpt);
addJsApi(copyOpt);
addJsApi(openUrlOpt);
addJsApi(refreshTokenOpt);
addJsApi(showLoginPanelOpt);
addJsApi(getSocialMediaTokenInfoOfPhoneOpt);
addJsApi(buyResourceOpt);
addJsApi(notifyBuyResultOpt);


/**
 *
 * @param obj
 * @param path
 * @param defaultValue
 * @param isUndefinedForced FIXME 由于原来默认值用null，为了兼容增加第四个值强制将defaultValue置成undefined
 * @returns {*}
 */
const getObjProps = (obj: Window & typeof globalThis, path: string, defaultValue = null, isUndefinedForced = true) => {
  try {
    const v = (path.split ? path.split('.') : [path]).reduce((o: { [x: string]: any; } | null | undefined, p: string | number) => (o === null || o === void 0 ? void 0 : o[p]), obj);
    return v === undefined && !isUndefinedForced ? defaultValue : v;
  } catch (error) {
    return !isUndefinedForced ? defaultValue : undefined;
  }
};

function getApi(api: any) {
  const executor = getObjProps(window, api);
  if (typeof executor !== 'function') {
    console.error(`qb jsapi not found: ${api}`);
    return;
  }
  return executor;
}
/**
/**
 *
 * @param api api字符 如browser.login.getAccountInfo
 * @param resolveIndex 成功回调参数位置 默认0 如不需要则设为<0
 * @param rejectIndex 失败回调参数位置 默认1 如不需要则设为<0
 * @returns
 */
function promisify(api: any, resolveIndex?: number, rejectIndex?: number) {
  return (...args: any) => new Promise((resolve, reject) => {
    const executor = getApi(api);
    if (typeof executor !== 'function') {
      return reject(`${api} is not available`);
    }
    const params = [...args];
    const resIndex = resolveIndex || 0;
    if (resIndex >= 0) {
      params.splice(resIndex, 0, resolve);
    }
    const rejIndex = rejectIndex || 1;
    if (rejIndex >= 0) {
      params.splice(rejIndex, 0, reject);
    }
    console.log('jsapi params', api, params);
    executor(...params);
  });
};
export const QBAccountModule = {
  /**
   * 获取上次登录类型
   * 返回 previousType: 0表示未知，1表示QQ，2表示微信，4表示QQ互联登录，6表示手机登录
   */
  getAccountInfo() {
    return promisify('browser.login.getAccountInfo')();
  },
  getPreviousLoginType() {
    return null;
  },
  /**
   * 业务需要在dataMap中传形如key_from_where: 10000，标记调用来源
   */
  refreshToken(option: any) {
    return promisify('browser.login.refreshToken', 1)(option);
  },
  showLoginPanel(fromWhere = '10000', dataMap: any) {
    return promisify('browser.login.showLoginPanel')({
      fromWhere,
      dataMap,
    });
  },
};

export const QBDeviceModule = {
  getDeviceInfo() {
    return promisify('browser.app.getBrowserParam')();
  },
  getQAID() {
    return promisify('browser.device.getQAID')();
  },
  getTAID() {
    return promisify('browser.device.getTAID')();
  },
  getOAID() {
    return promisify('browser.device.getOAID')();
  },
  getBattery() {
    return null;
  },
  copy(strCopy: string) {
    return promisify('browser.device.copy', 1, 2)(strCopy);
  },
};
export const QBAppModule = {
  showHalfFloatingView(option: any) {
    return promisify('browser.app.showHalfFloatingView')(option);
  },
  dismissHalfFloatingView() {
    return promisify('browser.app.dismissHalfFloatingView')();
  },
  openUrl(option: {
    url: string; // 打开链接地址
    newWindow?: string; // 是否新窗口打开
    animated?: string; // 是否需要动画，默认true-有打开页面动画（12.5.5支持）
  }) {
    console.log('🚀 ~ file: jsApi.ts:371 ~ export  QBAppModule.option.option:', option);
    return promisify('browser.app.openUrl')(option);
  },
};

export const QBLoginModule = {
  getSocialMediaTokenInfoOfPhone(option: any) {
    console.log('🚀 ~ file: jsApi.ts:377 ~ getSocialMediaTokenInfoOfPhone ~ option:', option);
    return promisify('browser.login.getSocialMediaTokenInfoOfPhone')(option);
  },
  showLoginPanel(option: any) {
    return promisify('browser.login.showLoginPanel')(option);
  }
};

